import { Api } from '@/interface/api';


 const competition_visited: Api = {
    url: '/api/project/proxy/api/competition_visited',
    method: 'post',
};

const guide_info: Api = {
    url: '/api/project/proxy/api/competitions/wapsite/guide-info',
    method: 'get',
};



export {
    competition_visited,
    guide_info
}
